








import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { css } from '@emotion/react';
import { ClipLoader } from 'react-spinners';
import AdminActions from './AdminActions';
import axios from "axios"
const override = css`
  display: block;
  margin: 0 auto;
`;

const JobSeekerTable = () => {
  const [jobSeekers, setJobSeekers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchJobSeekers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}jobseeker/allJobSeeker`, {
     
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });
         setJobSeekers(response.data);
      
      } catch (error) {
        console.error('Fetch Error:', error);
        toast.error('An error occurred while fetching job seekers');
      } finally {
        setLoading(false);
      }
    };
    fetchJobSeekers();
  }, []);

  const filteredJobSeekers = jobSeekers.filter(jobSeeker =>
    `${jobSeeker.firstName} ${jobSeeker.lastName}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-900">
        <ClipLoader color="#16F993FF" css={override} size={50} />
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-300 min-h-screen text-white">
      <h1 className="text-3xl font-bold mb-6 text-green-500"> Job Seekers - {jobSeekers.length > 0 ? jobSeekers.length : 0}</h1>
      <div className="mb-6">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by name..."
          className="p-3 border border-gray-700 rounded-md w-full md:w-1/3 bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>
      <div className="overflow-x-auto shadow-lg rounded-lg">
        <table className="w-full bg-gray-900 border-collapse">
          <thead>
            <tr className="bg-gray-700">
              <th className="border-b border-gray-600 p-4 text-left text-green-400">First Name</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Last Name</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Middle Name</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Email</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Date of Birth</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Address</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Address 2</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Race</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Disability</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">State</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Local Government</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Country</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Gender</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">User Type</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Avatar</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Phone Number</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Job Offers</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Applied Jobs</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Notifications</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Interested Job</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Resume</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Job Choice</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Account Balance</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Education</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Is Blacklisted</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Work Experience</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Certificates</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Guarantors</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Hired History</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Reports Made</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Reports Gotten</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Benefits</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Is Verified</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Last Login</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Unique Number</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredJobSeekers.map((jobSeeker) => (
              <tr key={jobSeeker._id} className="border-b border-gray-600 hover:bg-gray-700 transition-colors">
                <td className="border-r border-gray-600 p-4">{jobSeeker.firstName}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.lastName}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.middleName || 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.email}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.dateOfBirth || 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.address}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.address2 || 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.race || 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.dissability || 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.state}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.localGovernment}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.country}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.gender}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.userType}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.avatar || 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.phoneNumber}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.jobOffers?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.appliedJobs?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.notifications?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.interestedJob?.join(', ') || 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.resume?.join(', ') || 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.jobChoice?.join(', ') || 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.accountBalance}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.education?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.isBlacklisted ? 'Yes' : 'No'}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.workExperience?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.certificates?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.guarantors?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.hiredHistory?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.reportsMade?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.reportsGotten?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.benefits?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.isVerified ? 'Yes' : 'No'}</td>
                <td className="border-r border-gray-600 p-4">{new Date(jobSeeker.lastLogin).toLocaleString()}</td>
                <td className="border-r border-gray-600 p-4">{jobSeeker.uniqueNumber}</td>
                <td className="border-r border-gray-600 p-4">
                  {localStorage.getItem('userType') === 'admin' && (
                    <AdminActions jobSeekerId={jobSeeker._id} isBlacklisted={jobSeeker.isBlacklisted} />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default JobSeekerTable;